import { useSignOutMutation } from "./__gql__/sign-out.gen";
import { useRouter } from "next/router";
import { pagesPath } from "@/pathpida/generated/$path";

export const useSignOut = (): (() => Promise<void>) => {
  const router = useRouter();
  const [signOut] = useSignOutMutation();
  return async (): Promise<void> => {
    await Promise.all([signOut(), router.push(pagesPath.signin.$url())]);
  };
};
